import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const EmpresaContext = createContext(null);

export const EmpresaProvider = ({ children }) => {
  const [empresa, setEmpresa] = useState({
    nombre: 'TELECOM',
    nit: '',
    telefono: '',
    telefono2: '',
    direccion: '',
    ciudad: '',
    email: '',
    website: '',
    logo_base64: null,
    logo_mime: 'image/png',
    color_primario: '#00E5FF',
    pie_factura: '¡Gracias por su preferencia!',
  });

  const cargar = async () => {
    try {
      const { data } = await api.get('/api/configuracion');
      if (data && data.nombre) setEmpresa(data);
    } catch (e) { /* usa defaults */ }
  };

  useEffect(() => { cargar(); }, []);

  const actualizar = async (datos) => {
    const { data } = await api.put('/api/configuracion', datos);
    setEmpresa(data);
    return data;
  };

  const logoSrc = empresa.logo_base64
    ? `data:${empresa.logo_mime || 'image/png'};base64,${empresa.logo_base64}`
    : null;

  return (
    <EmpresaContext.Provider value={{ empresa, actualizar, cargar, logoSrc }}>
      {children}
    </EmpresaContext.Provider>
  );
};

export const useEmpresa = () => useContext(EmpresaContext);
